<template>
    <div>
        <form class="uk-form-stacked uk-grid-small uk-child-width-1-1" uk-grid>

            <div>
                <label class="uk-form-label" for="name">Name</label>
                <div class="uk-form-controls">
                    <input v-validate="'required|alpha'" name="Name" v-model="formData.User.first_name" class="uk-input" id="name" type="text">
                    <span class="help is-danger" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
                </div>
            </div>

            <div>
                <label class="uk-form-label" for="last_name">Last Name</label>
                <div class="uk-form-controls">
                    <input v-validate="'required|alpha'" name="Last Name" v-model="formData.User.last_name" class="uk-input" id="last_name" type="text">
                    <span class="help is-danger" v-show="errors.has('Last Name')">{{ errors.first('Last Name') }}</span>
                </div>
            </div>

            <div>
                <label class="uk-form-label" for="reg_email">Email</label>
                <div class="uk-form-controls uk-inline uk-width-1-1">
                    <span class="uk-form-icon" uk-icon="icon: mail"></span>
                    <input v-validate="'required|email'" v-model="formData.User.email" name="Email" class="uk-input" id="reg_email" type="email">
                    <span class="help is-danger" v-show="errors.has('Email')">{{ errors.first('Email') }}</span>
                </div>
            </div>

            <div>
                <label class="uk-form-label" for="reg_password">Password</label>
                <div class="uk-form-controls uk-inline uk-width-1-1">
                    <span class="uk-form-icon" uk-icon="icon: lock"></span>
                    <input
                            v-model="formData.User.password"
                            placeholder="Minimum 6 characters"
                            v-validate="'required|min:6'"
                            class="uk-input"
                            id="reg_password"
                            type="password"
                            name="password"
                    >
                    <span class="help is-danger" v-show="errors.has('password')">{{ errors.first('password') }}</span>
                </div>
            </div>

            <div>
                <label class="uk-form-label" for="password_confirm">Password Confirm</label>
                <div class="uk-form-controls uk-inline uk-width-1-1">
                    <span class="uk-form-icon" uk-icon="icon: lock"></span>
                    <input v-model="formData.User.password_confirm"
                           class="uk-input"
                           id="password_confirm"
                           type="password"
                           name="Confirm Password"
                           v-validate="'required|confirmed:password'"
                    >
                    <span class="help is-danger" v-show="errors.has('Confirm Password')">{{ errors.first('Confirm Password') }}</span>
                </div>
            </div>

            <div>
                <button @click.prevent="signUp" class="uk-margin uk-button uk-button-primary uk-width-1-1">Sign Up</button>
            </div>

        </form>
    </div>
</template>
<script>
    export default {
        data(){
            return {
                formData: {
                    User: {
                        first_name: '',
                        last_name: '',
                        email: '',
                        password: '',
                        password_confirm: '',
                    }
                }
            }
        },
        methods: {
            signUp(){
                this.$http.post('/users/signUp', this.formData).then(response => {
                    // success callback
                    console.log(response)
                }, response => {
                    // error callback
                });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// SignUp.vue?746312b1